module.exports = __webpack_public_path__ + "img/invoice-de-male-sh.09794793.png";